<template>
  <div>
    <Module ref="Module"
    :title="''"
    :desc="''"
    :moreTitle="''"
    :fetchCache="fetchCache"
    :fetchRequest="fetchRequest"
    :checkData="checkData"
    :slotNextTick="slotNextTick">
      <div slot-scope="slotProps">
        <div v-for="(item, index) in slotProps.list"
        :key="index">
          <div class="chart-canvas-wrap">
            <div v-if="needTips" class="scale-tips" @click="showTips" >
              <span class="tips-icon"></span>
              <span class="tips-text">为什么基金规模和净资产不一致？</span>
            </div>
            <canvas id="scale-chart"></canvas>
          </div>
        </div>
      </div>
    </Module>
  </div>
</template>

<script>
import Module from '@/components/Module.vue';
import StoreManger from '@/utils/FundHQJHManger';
// eslint-disable-next-line import/extensions
import F2 from './libs/f2.js';
import { scale as config } from './config';
// import Model from './model';
import drawScale from './draw/scale';

export default {
  props: ['showEmpty'],
  components: {
    Module,
  },
  data() {
    return {
      FCODE: '',
      publicParams: {},
      needTips: false,
      webw: 360,
    };
  },
  created() {
    const timer = setInterval(() => {
      if (window.holdAllMoney && window.scaleAllMoney) {
        const scaleAllMoneys = window.scaleAllMoney / 100000000;
        const holdAllMoneys = window.holdAllMoney / 1;
        this.needTips = holdAllMoneys.toFixed(2) !== scaleAllMoneys.toFixed(2);
        clearInterval(timer);
      }
    }, 300);
  },
  mounted() {
    // #if EXECUTION_ENV == 'web'
    // eslint-disable-next-line no-undef
    const webPlatf = multi.$system.webPlatform;
    if (webPlatf === 'wap') {
      this.webw = window.innerWidth - 60;
    }
    // #endif
  },
  methods: {
    showTips() {
      this.$feedback.showModal({
        title: '温馨提示',
        content: '当前基金存在不同份额类型，不同份额类型的基金统一管理。【基金持仓】中的净资产数据为所有份额基金净资产的合计。【基金规模】中的数据为当前基金的净资产。',
        confirmText: '知道了',
        showCancel: false,
        confirmColor: '#2f7eff',
        success: () => {},
      });
    },
    render() {
      this.config = config;
      this.FCODE = this.$store.state.native.fund.fundCode || '000001';
      this.baseInfo = StoreManger.getFundJJXQ();

      if (!this.baseInfo) {
        this.$props.showEmpty();
        return;
      }

      this.$getUserInfo().then((info) => {
        const {
          uid, deviceid, ctoken, utoken,
        } = info;
        this.publicParams = {
          CustomerNo: uid,
          UserId: uid,
          Uid: uid,
          CToken: ctoken,
          UToken: utoken,
          MobileKey: deviceid,

          deviceid: '5C1164BA-3D4A-4953-A488-00E47222D4BB' || deviceid,
          plat: 'Iphone',
          AppType: 'Iphone',
          product: 'EFund',
          version: '6.2.5',
          Serverversion: '6.2.5',
          appversion: '6.2.5',
        };
        if (this.$refs.Module) {
          this.$refs.Module.start();
        }
      });
    },
    fetchCache() {
      return null;
    },
    fetchRequest() {
      return new Promise((resolve) => {
        const res = StoreManger.getFundJJGM();
        if (!res?.Datas?.length) {
          this.$props.showEmpty();
          return;
        }
        const data = drawScale.formatData(res, this.baseInfo.ESTABDATE);
        let isempty = true;
        for (let index = 0; index < data.length; index += 1) {
          const element = data[index];
          if (element.nav !== 0) {
            isempty = false;
          }
        }
        if (isempty) {
          // 都是0也要空 ，王强
          this.$props.showEmpty();
          return;
        }
        const resData = [];
        if (data) {
          resData.push(data);
        }
        resolve(resData);
      });
    },
    checkData(data) {
      return (data && Object.prototype.toString.call(data) === '[object Array]' && data.length > 0);
    },
    slotNextTick(list) {
      const chartv = document.getElementById('scale-chart');
      if (!chartv) {
        return;
      }
      if (!this.checkData(list)) {
        return;
      }
      this.updateChart(list[0]);
    },
    // 更新图表
    async updateChart(data) {
      // 创建图表实例
      // #if EXECUTION_ENV === 'fund'
      if (window.innerWidth < 200) {
        // eslint-disable-next-line no-undef
        const systemInfo = fund.getSystemInfoSync();
        window.innerWidth = systemInfo.windowWidth / systemInfo.pixelRatio;
      }
      // #endif

      let inweb = false;
      // #if EXECUTION_ENV == 'web'
      // eslint-disable-next-line no-undef
      const webPlatf = multi.$system.webPlatform;
      if (webPlatf === 'wap') {
        inweb = true;
      }
      // #endif
      const chart = new F2.Chart({
        id: 'scale-chart',
        pixelRatio: window.devicePixelRatio,
        width: inweb ? this.webw : window.innerWidth - 60,
      });
      // 加载数据
      // const row = await Model.FundMNAssetsList(this.publicParams, this.FCODE);

      try {
        window.scaleAllMoney = data[data.length - 1].nav;
      } catch (err) {
        console.error(err);
      }
      // // 格式化数据
      // const data = drawScale.formatData(row);
      // 创建图表
      drawScale.drawChart(data, chart);
    },

  },
};
</script>

<style scoped lang="less">
  #scale-chart {
    height: 430px;
  }
</style>
